import store from "../../../store";
import { ReceptionDetailStatusSearchCondition, ReceptionSearchActiveKinds, WorkflowStatusSearchCondition } from ".";
import { InOutKinds, InOutKindsName, ReceptionDateKinds, ReceptionDateKindsName } from "../kinds";

import { Patient } from "../../patient";
import { DateDuration } from "../../system";
import { ReceptionInputSection, WorkflowStatusName } from "../items";
import { User } from "../../user";
import { Department } from "../../department";
import { FormatReference } from "../../format";
import { ReceptionDateTranslator } from "../ReceptionDateTranslator";
import { IConfiguration } from "../../../domain/configuration";

// 依頼詳細検索（WF進捗別）条件
export class ReceptionDetailProgressSearchCondition {
  dateKind: ReceptionDateKinds;
  duration: DateDuration;
  
  deliveryLimitDate: DateDuration;
  limitDate: DateDuration;

  patient: Patient;
  formats: FormatReference[];
  paperName: string;
  managers: User[];
  isDepartmentGroupSpecified: boolean;
  departments: Department[];
  generalFlag1Status: ReceptionSearchActiveKinds;
  statuses: ReceptionDetailStatusSearchCondition;
  workflowStatus: WorkflowStatusSearchCondition;
  inputSection: ReceptionInputSection;
  inOutType: InOutKinds;

  isMyselfOnly: boolean;

  private _dateTranslator: ReceptionDateTranslator;

  constructor() {
    this.duration = new DateDuration(null, null);
    this.deliveryLimitDate = new DateDuration(null, null);
    this.limitDate = new DateDuration(null, null);
    this.statuses = new ReceptionDetailStatusSearchCondition();
    this.formats = [];
    this.managers = [];
    this.isDepartmentGroupSpecified = false;
    this.departments = [];
    this.generalFlag1Status = ReceptionSearchActiveKinds.NotSpecificated;
    this.workflowStatus = new WorkflowStatusSearchCondition();
    this.inputSection = null;
    this.inOutType = InOutKinds.None;
    this._dateTranslator = new ReceptionDateTranslator();
  }

  setWorkflowStatus(status: WorkflowStatusName) {
    this.workflowStatus = new WorkflowStatusSearchCondition();
    this.workflowStatus.isSelected = true;
    this.workflowStatus.status = status; // 参照大丈夫？
  }

  needConfirmFinish(): boolean {
    // ※このチェックを行うのは終了進捗のみ
    if (this.duration.from && this.duration.to && this.duration.years <= 5) {
      // 期間指定があり、期間が5年以内
      return false;
    }
    if (this.patient) {
      // 患者が選択されている
      return false;
    }

    return true;
  }

  getSummary(generalFlag1Name: string): string {
    const config = store.getters.configuration as IConfiguration;
    let summary = "";
    summary = this.toDurationString(this.dateKind, this.duration) + 
      this.toDurationString(ReceptionDateKinds.LimitDate, this.limitDate) +
      this.toDurationString(ReceptionDateKinds.DeliveryLimitDate, this.deliveryLimitDate) +
      (this.patient ? this.toItemString("患者番号", this.patient.id) : "") +
      (this.formats.length > 0 ? this.toItemString(config.wording.format.attributes.name + "名", "指定あり") : "") +
      (this.paperName ? this.toItemString("手書き" + config.wording.format.attributes.name + "名", this.paperName) : "") +
      (this.managers.length > 0 ? this.toItemString("対応責任者", "指定あり") : "") +
      (this.inputSection ? this.toItemString("入力部署", this.inputSection.name) : "") +
      (this.isDepartmentGroupSpecified ? this.toItemString(config.wording.common.departmentGroup, "指定あり") : "") +
      (this.departments.length > 0 ? this.toItemString(config.wording.common.department, "指定あり") : "") +
      (this.generalFlag1Status !== ReceptionSearchActiveKinds.NotSpecificated
        ? generalFlag1Name + (this.generalFlag1Status === ReceptionSearchActiveKinds.Activated ? " " : "なし ")
        : "") +
      (this.inOutType !== InOutKinds.None ? this.toItemString("入院/外来", InOutKindsName.getDisplayName(this.inOutType)) : "") +
      (this.isMyselfOnly ? "自分が実施したもの" : "") +
      this.toItemString("ステータス", this.statuses.getSummary());
  
    return summary;
  }

  private toDurationString(kind: ReceptionDateKinds, value: DateDuration): string {
    if (value && (value.from || value.to)) {
      return ReceptionDateKindsName.getDisplayName(kind) + "：" + this._dateTranslator.toDateDispString(value.from) + "～" + this._dateTranslator.toDateDispString(value.to) + " ";
    } 
    return "";
  }

  private toItemString(itemLabel: string, value: string): string {
    if (value.length === 0) { return ""; }
    return itemLabel + "：" + value + " ";
  }


  clone(): ReceptionDetailProgressSearchCondition {
    const newObj = new ReceptionDetailProgressSearchCondition();
    newObj.dateKind = this.dateKind;
    newObj.duration = this.duration;
    newObj.deliveryLimitDate = this.deliveryLimitDate;
    newObj.limitDate = this.limitDate;
    newObj.patient = this.patient;
    newObj.formats = this.formats;
    newObj.paperName = this.paperName;
    newObj.managers = this.managers;
    newObj.isDepartmentGroupSpecified = this.isDepartmentGroupSpecified;
    newObj.departments = this.departments;
    newObj.generalFlag1Status = this.generalFlag1Status;
    newObj.statuses = this.statuses.clone();
    newObj.workflowStatus = this.workflowStatus.clone();
    newObj.inputSection = this.inputSection;
    newObj.inOutType = this.inOutType;
    newObj.isMyselfOnly = this.isMyselfOnly;

    return newObj;
  }
}
